module.exports = "/contribution/resources/c4472a3c62119358ca3d0b7ae69622da.ttf";